// @flow

import * as React from 'react';
import BootstrapModal from 'react-bootstrap/lib/Modal';

type Props = {
  show: () => mixed,
  onHide: boolean,
  children: ({ showContent: boolean }) => React.Node,
};

type State = {
  showContent: boolean,
};

export default class ModalAction extends React.Component<Props, State> {
  state = {
    showContent: false,
  };

  onEntered = () => {
    this.setState({
      showContent: true,
    });
  };

  onExited = () => {
    this.setState({
      showContent: false,
    });
  };

  render() {
    return (
      <BootstrapModal
        onEntered={this.onEntered}
        onExited={this.onExited}
        bsSize="large"
        show={this.props.show}
        onHide={this.props.onHide}
      >
        {this.props.children({
          showContent: this.state.showContent,
        })}
      </BootstrapModal>
    );
  }
}
